import { swalMessage } from '@components/common';
import type { KioskUpdateReceipt } from '@lib/socket';
import Swal from 'sweetalert2';

export const showKioskUpdateReceipt = async (pending: Promise<KioskUpdateReceipt>) => {
  void Swal.fire({
    title: '기기 수신 확인 중',
    text: '설치 완료 여부는 업데이트 후 버전 목록에서 확인해주세요.',
    showConfirmButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => Swal.showLoading(),
  });
  const result = await pending;
  Swal.close();
  if (!result.success || result.status !== 'received') {
    return swalMessage('warning', result.error || '기기 수신을 확인하지 못했습니다.');
  }
  return swalMessage('info', result.requiresInteraction
    ? '기기가 업데이트 확인 요청을 받았습니다. 새 버전이 있으면 현장에서 설치 조작이 필요합니다. 설치 완료 여부는 버전 목록에서 확인해주세요.'
    : '기기가 업데이트 확인 요청을 받았습니다. 설치 완료를 의미하지 않습니다. 다시 연결된 뒤 버전 목록에서 확인해주세요.');
};
